export default __webpack_public_path__ + "static/media/Footer patch-02.66246eb9.svg";